import { STUDY_TOOLS } from './studyTools';

const TOOL_ROUTE = /^\/learn\/study\/subjects\/([a-z0-9-]+)\/tools\/([a-z0-9-]+)\/?$/;

export interface StudyToolRoute {
  subjectKey: string;
  /** The catalogue id (`StudyTool.id`), which is the key Institution policy stores. */
  toolId: string;
}

/** Maps a Learn tool URL to its subject and catalogue id, or null for any other page. */
export function studyToolRoute(pathname: string): StudyToolRoute | null {
  const match = TOOL_ROUTE.exec(pathname);
  if (!match) return null;
  const path = pathname.replace(/\/$/, '');
  const tool = STUDY_TOOLS.find((entry) => entry.path === path);
  return { subjectKey: match[1], toolId: tool?.id ?? match[2] };
}
